<template>
    <div 
        v-bind="$attrs" 
        class="avatar" 
        :class="[
            `avatar-${type}`, 
            `avatar-${borderStyle}`, 
            loading ? 'disabled' : '', 
            showUpload ? 'cursor-pointer' : ''
        ]" 
        :style="styles"
        @click="showUpload ? handleFileBtnClick() : null"
        @mouseenter="showUpload ? handleMouseEnter() : null"
        @mouseleave="showUpload ? handleMouseLeave() : null"
    >
        <template v-if="!loading">
            <div class="w-100 flex align-items-center justify-content-center p-2" style="max-width: 97%;">
                <img v-if="src" :src="src" class="w-100">
                <span v-else>{{ initials }}</span>
            </div>
        </template>
        <template v-else>
            <PageSpinner
                size="sm" 
                :is-page="false"
            />
        </template>
        <template v-if="showUpload">
            <input
                ref="avatarFileRef"
                type="file"
                :accept="'image/*'"
                :style="{ display: 'none' }"
                @change="e => handleFileChange(e)"
                @click.stop="() => {}"
            >
        </template>

        <div v-if="isHover" class="icon-cover">
            <svg
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24"
                viewBox="0 0 24 24"
                style="transform: ;msFilter:;"
            >
                <path d="M12 8c-2.168 0-4 1.832-4 4s1.832 4 4 4 4-1.832 4-4-1.832-4-4-4zm0 6c-1.065 0-2-.935-2-2s.935-2 2-2 2 .935 2 2-.935 2-2 2z" />
                <path d="M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 18V7h3c.266 0 .52-.105.707-.293L10.414 4h3.172l2.707 2.707A.996.996 0 0 0 17 7h3l.002 11H4z" />
            </svg>
        </div>
    </div>
</template>

<script>
import PageSpinner from "../loaders/PageSpinner.vue";

export default {
    name: "CustomAvatar",

    components: { PageSpinner },

    props: {
        initials: {
            type: String,
            default: "",
        },   
        src: {
            type: String,
            default: "",
        },     
        width: {
            type: String,
            default: "2.25rem",
        },
        showUpload: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        borderStyle: {
            type: String,
            default: "solid",
            validator: (value) => {
                return ["outline", "solid"].includes(value);
            },
        },
        type: {
            type: String,
            default: "circle",
            validator: (value) => {
                return ["square", "circle"].includes(value);
            },
        },
    },

    emits: ["update:files"],

    data() {
        return {
            isHover: false,
        };
    },

    computed: {
        styles() {
            const sty = {
                width: this.width,
                height: this.width,
                transition: "",
                background: "",
            };

            if (this.type === "circle") {
                sty.borderRadius = "100%";
            }  
            
            if (this.type === "square") {
                sty.borderRadius = "5px";
            }

            return sty;
        },
    },

    methods: {
        handleFileBtnClick(){  
            this.$refs?.avatarFileRef?.click();
        },

        handleFileChange(event){                    
            const file = (event.target)?.files[0];
            
            this.$emit("update:files", file);

            if (event.target) {
                event.target.value = "";
            }
        },

        handleMouseEnter() {
            this.isHover = true;
        },

        handleMouseLeave() {
            this.isHover = false;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        flex-shrink: 0;
        overflow: visible;
        overflow: hidden;
        position: relative;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
        font-weight: 600;
        font-size: 0.75rem;
        text-transform: uppercase;
        font-style: normal;
        position: relative;
       
        &-circle {
            border-radius: 100%;
        }

        &-square {
            border-radius: 5px !important;
        }

        &-solid {
            background: rgb(218, 222, 231);
            background: #0000000a;
            border: 0.5px solid #00000017;
            color: var(--neutral-800)
        }

        &-outline {
            border: 1px solid #A0AEC0;
            background: transparent !important;
            color: #A0AEC0;
        }
    }

    .icon-cover {
        position: absolute;
        top: 0;
        left: 0;
        background: blue;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        background: #bac0cf;

        svg {
            fill: #fff;
        }
    }
</style>